module.exports = __webpack_public_path__ + "static/media/bat-login-dark.80cbe8ee.png";